export function getStaticImageBucketEndpoint(isProduction: boolean) {
  return isProduction
    ? "https://public.fjob-kyujin.com"
    : "https://preview.public.fjob-kyujin.com";
}
